import cx from 'classnames';
import TagsUFs from 'govbr.frontend.policy/components/TagsUFs';

import styles from './Listing.module.less';
import { Description, Thumbnail, Title } from './ListingParts';
export const Image = ({ item, isEditMode }) => {
  return (
    <div className={styles.body}>
      <div className={cx(styles.body, styles.mediaGallery)}>
        <Title item={item} isEditMode={isEditMode} />
        <Thumbnail item={item} isEditMode={isEditMode} />
        <Description item={item} hideDatePublished />
        <TagsUFs
          className={'mt-1 mt-sm-0'}
          content={{
            subjects: item?.subjects || item?.Subject,
          }}
        />
      </div>
    </div>
  );
};
